<tbs-switch
  tbsSize="small"
  tbsTooltipPlacement="right"
  [tbsDisabled]="isDisabled"
  [ngModel]="isChecked"
  [tbs-tooltip]="isDisabled && tooltip ? tooltip : ''"
  (ngModelChange)="toggleCheck($event)"
/>
